var React = require('react');

function Tape (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M624 416H380.6A223.47 223.47 0 0 0 448 256c0-123.7-100.3-224-224-224S0 132.3 0 256s100.3 224 224 224h400a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-400-64a96 96 0 1 1 96-96 96 96 0 0 1-96 96z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M288 256a64 64 0 1 1-64-64 64.06 64.06 0 0 1 64 64z","className":"fa-primary","key":2})]);
}

Tape.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = Tape;

Tape.default = Tape;
